module.exports = __webpack_public_path__ + "static/media/shape.e4dba5f1.svg";